import { beforeUnloadDialog } from '@pc/components/BeforeUnloadDialog'
import { displayCategoryTextarea } from '@pc/components/Informations/DisplayCategoryTextarea'

document.addEventListener('DOMContentLoaded', () => {
  // 「問い合わせカテゴリ」のその他を選択した時のテキストエリア(ユーザー向け)
  displayCategoryTextarea()

  // 離脱防止・submit時ダイアログ
  beforeUnloadDialog('js-ask-form', true)
})
